<template>
  <div>
    <!-- <div class="add-title">
      <span>试题管理 /</span>
      {{$route.query.upId?"编辑大题":"添加大题"}}
    </div>-->
    <el-card style="margin-bottom:20px;font-size:14px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          :to="($route.query.chapterId||$route.query.examId)?{ path: '/examView',query:{
         chapterId: $route.query.chapterId,
         examId: $route.query.chapterId
        } }:{ path: '/question' }"
        >试题管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.query.upId?"编辑大题":"添加大题"}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <div id="addQuestion">
      <div style="width:70%;background: #fff;">
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
          <el-row :span="24">
            <el-col :span="12">
              <el-form-item
                v-if="!$route.query.chapterId&&!$route.query.examId"
                label="具体课程"
                prop="courseId"
              >
                <el-cascader
                  clearable
                  :show-all-levels="false"
                  :props="subjectTreeProps"
                  placeholder="请输入具体课程"
                  v-model="addForm.courseId"
                  :options="subjectTreeList"
                  @change="subjectChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="试题题型" prop="questionTypeId">
                <el-select
                  :disabled="$route.query.upId?true:false"
                  clearable
                  v-model="addForm.questionTypeId"
                  placeholder="请输入试题题型"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :span="12">
              <el-form-item label="是否上架" prop="state">
                <el-radio-group v-model="addForm.state">
                  <el-radio :label="1">上架</el-radio>
                  <el-radio :label="-1">下架</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="$route.query.chapterId||$route.query.examId">
              <el-form-item label="排序" prop="sort">
                <el-input style="width:200px;" type="number" v-model="addForm.sort"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :span="24">
              <el-form-item label="大题题干" prop="title">
                <div style="background: #FFF" v-if="showUe">
                  <UE :value="ueTtext" name="1" ref="myQuillEditorTitle"></UE>
                </div>
              </el-form-item>
            </el-col>
            <!-- 
        <el-col :span="24">
          <el-form-item>
            <div class="add-list">
              <div class="list-item" v-for="item in 2" :key="item">
                试题{{item}}
                <i class="iconfont iconicon7"></i>
              </div>

              <div class="list-item">
                <i class="iconfont iconicon-test"></i>
                添加试题
              </div>
            </div>
          </el-form-item>
            </el-col>-->
          </el-row>
          <el-row :span="24">
            <el-col :span="24">
              <el-form-item>
                <div>
                  <el-button @click="goBack()">取 消</el-button>
                  <el-button type="primary" @click="addQuestion">确 定</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import UE from "./CKEditor.vue";
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routerPath = from.path;
    });
  },
  components: { UE },
  data() {
    return {
      typeList: [], //试题类型
      routerPath: "",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      tableData: [{ name: "", options: "A" }],
      ueTtext: "",
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      formLabelWidth: "80px",
      addForm: {
        questionTypeId: "",
        courseId: "",
        state: 1,
        title: ""
      },
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属科目",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属科目格式不正确"
          }
        ],

        state: [
          {
            required: true,
            message: "请选择是否上架",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确"
          }
        ],

        title: [
          {
            required: true,
            message: "请输入标题题干",
            trigger: "blur"
          },
          {
            min: 1,
            max: 4000,
            message: "标题题干长度在1到4000个字"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      checkAddArray: [],
      showOptions: true, //试题选项
      showUe: true, //试题选项
      subjectTreeList: [] //科目，
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.upId) {
      this.getTitleById(this.$route.query.upId);
    }
    this.getSubjectTreeList();
  },
  methods: {
    // 获取大题信息
    getTitleById(id) {
      this.showUe = false;
      let obj = {
        id: id
      };
      if (this.$route.query.chapterId) {
        obj.chapterId = this.$route.query.chapterId;
      }
      this.api.question.getInfoById(obj).then(result => {
        if (result.success) {
          this.addForm = {
            courseId: result.data.courseId,
            state: result.data.state,
            sort: result.data.sort,
            title: result.data.title,
            id: result.data.id
          };
          this.ueTtext = result.data.title;
          this.showUe = true;
        }
      });
    },
    // 具体课程change事件
    subjectChange(val) {
      if (val.length > 0) {
        this.addForm.courseId = val[val.length - 1];
      } else {
        this.addForm.courseId = "";
      }
    },

    //   获取下拉
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
      // 获取试题类型
      this.api.question
        .questionTypeBigList()
        .then(result => {
          this.typeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //   返回上一页
    goBack() {
      if (this.$route.query.chapterId) {
        this.$router.push({
          path: "/chapterView",
          query: {
            chapterId: this.$route.query.chapterId || ""
          }
        });
      } else if (this.$route.query.examId) {
        this.$router.push({
          path: "/examView",
          query: {
            examId: this.$route.query.examId || ""
          }
        });
      } else if (this.routerPath) {
        this.$router.push({
          path: this.routerPath,
          query: {
            id: this.$route.query.idsss
          }
        });
      }
    },
    // 添加问题
    addQuestion() {
      if (!this.$refs.myQuillEditorTitle._data.content) {
        return this.$message.error("大题题干不能为空");
      }
      let apiStyle = "";
      if (this.$route.query.upId) {
        apiStyle = "updateBigQuestion";
      } else {
        apiStyle = "addBigQuestion";
      }
      this.addForm.title = this.$refs.myQuillEditorTitle._data.content;
      // this.addForm.title=this.addForm.title
      //   .replace(this.addForm.title ? /&(?!#?\w+;)/g : /&/g, "&amp;")
      //   .replace(/&lt;/g, "<")
      //   .replace(/&gt;/g, ">")
      //   .replace(/&quot;/g, '"')
      //   .replace(/&#39;/g, "'");
      if (this.$route.query.examId) {
        this.addForm.examId = this.$route.query.examId || "";
      }
      if (this.$route.query.chapterId) {
        this.addForm.chapterId = this.$route.query.chapterId || "";
      }
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.question[apiStyle](this.addForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                if (apiStyle == "addBigQuestion") {
                  this.$confirm(
                    "大题已添加成功, 是否继续在此大题下添加小题?",
                    "提示",
                    {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning"
                    }
                  )
                    .then(() => {
                      this.$router.push({
                        path: "/addQuestion",
                        query: {
                          id: result.data
                        }
                      });
                    })
                    .catch(() => {
                      this.goBack();
                    });
                } else {
                  this.goBack();
                }
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
#addQuestion {
  width: 100%;
  height: 100%;
  background: #fff;
  padding-top: 10px;
  .add-title {
    height: 60px;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    line-height: 60px;
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;

    span {
      color: rgb(162, 170, 188);
      font-size: 18px;
      margin-left: 20px;
    }
  }
  .th-display {
    display: flex;
    flex-direction: row;
    .add-option {
      width: 6%;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      background: #fff;
      i {
        font-size: 20px;
        margin-top: 10px;
      }
    }
    th {
      display: none;
    }
  }
  .content-text {
    width: 100px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    border: 1px solid rgb(77, 148, 255);
    color: rgb(77, 148, 255);
    font-size: 12px;
    text-align: center;
    background: #fff;
  }
  .add-list {
    display: flex;
    flex-direction: row;
    .list-item {
      margin-right: 30px;
      color: #4d94ff;
      font-size: 14px;
      font-weight: bold;
      border-bottom: rgb(246, 249, 250) solid 2px;

      &:hover {
        border-bottom: #4d94ff solid 2px;
        box-sizing: border-box;
      }
      i {
        color: #4d94ff;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .list-item:last-child {
      &:hover {
        border-bottom: rgb(246, 249, 250) solid 2px;
        box-sizing: border-box;
      }
      cursor: pointer;
    }
  }
  .el-rate {
    line-height: 2 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/question/addCpQuestion.vue